import { render } from "./DetailHost.vue?vue&type=template&id=39d4f50c"
import script from "./DetailHost.vue?vue&type=script&lang=js"
export * from "./DetailHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__